import React from 'react'

import Header from '../components/header'
import Footer from '../components/footer'
import '../assets/scss/main.scss'
import ContactSlideout from '../components/contact-slideout'
import useLayoutQuery from '../hooks/use-layout-query'

const Layout = ({ children, location, pageContext }) => {

  const query = useLayoutQuery()

  return (
    <>
      <Header location={location} context={pageContext} {...query} />
      <main>{children}</main>
      <Footer {...query} />
      <ContactSlideout />
    </>
  )
}

export default Layout